import { Link } from "react-router-dom";
import "./Onay.css";
import { Publish } from "@material-ui/icons";

export default function Onay() {
  return (
    <div className="onay">
      <div className="productTitleContainer">
        <h1 className="productTitle">Kullanıcı Onayı</h1>
      </div>
      <div className="onay-container">
        <div className="onayLeft">
          <h2>abdurrahman Subh</h2>
        </div>
        <div className="onayCenter">
          <h3>Instagram: </h3>
        </div>
        <div className="onayRight">
          <form action="#" method="#">
            <div className="inputContainer">
              <input type="radio" id="onay" name="cevap" value="onay" />
              <label for="html">Onay Ver</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="ret" name="cevap" value="ret" />
              <label for="css">Ret Et</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="bekleyen" name="cevap" value="bekleyen" />
              <label for="javascript">Beklet</label>
            </div>
            <div className="inputContainerSubmit">
              <input className="submit" type="submit" />
            </div>
          </form>
        </div>
      </div>
      <div className="onay-container">
        <div className="onayLeft">
          <h2>abdurrahman Subh</h2>
        </div>
        <div className="onayCenter">
          <h3>Instagram: </h3>
        </div>
        <div className="onayRight">
          <form action="#" method="#">
            <div className="inputContainer">
              <input type="radio" id="onay" name="cevap" value="onay" />
              <label for="html">Onay Ver</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="ret" name="cevap" value="ret" />
              <label for="css">Ret Et</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="bekleyen" name="cevap" value="bekleyen" />
              <label for="javascript">Beklet</label>
            </div>
            <div className="inputContainerSubmit">
              <input className="submit" type="submit" />
            </div>
          </form>
        </div>
      </div>
      <div className="onay-container">
        <div className="onayLeft">
          <h2>abdurrahman Subh</h2>
        </div>
        <div className="onayCenter">
          <h3>Instagram: </h3>
        </div>
        <div className="onayRight">
          <form action="#" method="#">
            <div className="inputContainer">
              <input type="radio" id="onay" name="cevap" value="onay" />
              <label for="html">Onay Ver</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="ret" name="cevap" value="ret" />
              <label for="css">Ret Et</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="bekleyen" name="cevap" value="bekleyen" />
              <label for="javascript">Beklet</label>
            </div>
            <div className="inputContainerSubmit">
              <input className="submit" type="submit" />
            </div>
          </form>
        </div>
      </div>
      <div className="onay-container">
        <div className="onayLeft">
          <h2>abdurrahman Subh</h2>
        </div>
        <div className="onayCenter">
          <h3>Instagram: </h3>
        </div>
        <div className="onayRight">
          <form action="#" method="#">
            <div className="inputContainer">
              <input type="radio" id="onay" name="cevap" value="onay" />
              <label for="html">Onay Ver</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="ret" name="cevap" value="ret" />
              <label for="css">Ret Et</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="bekleyen" name="cevap" value="bekleyen" />
              <label for="javascript">Beklet</label>
            </div>
            <div className="inputContainerSubmit">
              <input className="submit" type="submit" />
            </div>
          </form>
        </div>
      </div>
      <div className="onay-container">
        <div className="onayLeft">
          <h2>abdurrahman Subh</h2>
        </div>
        <div className="onayCenter">
          <h3>Instagram: </h3>
        </div>
        <div className="onayRight">
          <form action="#" method="#">
            <div className="inputContainer">
              <input type="radio" id="onay" name="cevap" value="onay" />
              <label for="html">Onay Ver</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="ret" name="cevap" value="ret" />
              <label for="css">Ret Et</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="bekleyen" name="cevap" value="bekleyen" />
              <label for="javascript">Beklet</label>
            </div>
            <div className="inputContainerSubmit">
              <input className="submit" type="submit" />
            </div>
          </form>
        </div>
      </div>
      <div className="onay-container">
        <div className="onayLeft">
          <h2>abdurrahman Subh</h2>
        </div>
        <div className="onayCenter">
          <h3>Instagram: www.instagram.com/abdurrahman_jsajfsajfjsubh </h3>
        </div>
        <div className="onayRight">
          <form action="#" method="#">
            <div className="inputContainer">
              <input type="radio" id="onay" name="cevap" value="onay" />
              <label for="html">Onay Ver</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="ret" name="cevap" value="ret" />
              <label for="css">Ret Et</label>
            </div>
            <div className="inputContainer">
              <input type="radio" id="bekleyen" name="cevap" value="bekleyen" />
              <label for="javascript">Beklet</label>
            </div>
            <div className="inputContainerSubmit">
              <input className="submit" type="submit" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
